var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"item next-pattern-information-content"},[_vm._v("\n    Next shape: "+_vm._s(_vm.patternName)+"\n")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87db9b48","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/implementations/uk/bingo-75/_components/pattern/next-pattern/next-pattern.html
// module id = null
// module chunks = 